import { useEffect } from "react";
import axios from "axios";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { URL } from "../constants";

function TransparentLoginBootstrap() {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const accessToken = searchParams.get("uta");
    const refreshToken = searchParams.get("utr");
    const redirectLink = searchParams.get("link") || "/";

    if (!accessToken) {
      return;
    }

    let isMounted = true;

    const bootstrapLogin = async () => {
      try {
        const authHeaders = {
          Authorization: `JWT ${accessToken}`,
          "Content-Type": "application/json",
          "Accept-Language": "en-US,en;q=0.9",
        };

        const { data: details } = await axios.get(`${URL}auth/users/me`, {
          headers: authHeaders,
        });

        if (
          details.role !== "realty_agent" &&
          details.role !== "client"
        ) {
          localStorage.clear();
          dispatch({ type: "LOGOUT_USER" });
          navigate("/", { replace: true });
          return;
        }

        const [{ data: favs }, { data: subscriptions }] = await Promise.all([
          axios.get(`${URL}favorite/properties/${details.id}`, {
            headers: authHeaders,
          }),
          axios.get(`${URL}register/subscriptions/`, {
            headers: authHeaders,
            params: {
              user_id: details.id,
            },
          }),
        ]);

        if (!isMounted) return;

        localStorage.setItem("uta", accessToken);
        localStorage.setItem("utr", refreshToken);
        localStorage.setItem("udt", JSON.stringify(details));
        localStorage.setItem("ufv", JSON.stringify(favs.favorites));
        localStorage.setItem(
          "usub",
          subscriptions?.length > 0 ? JSON.stringify(subscriptions[0]) : "",
        );

        dispatch({
          type: "LOGIN_USER",
          payload: {
            ...details,
            refreshToken,
            accessToken,
            favs: favs.favorites,
          },
        });

        navigate(redirectLink, { replace: true });
      } catch (error) {
        if (!isMounted) return;
        localStorage.clear();
        dispatch({ type: "LOGOUT_USER" });
        navigate("/", { replace: true });
      }
    };

    bootstrapLogin();

    return () => {
      isMounted = false;
    };
  }, [dispatch, location.search, navigate]);

  return null;
}

export default TransparentLoginBootstrap;
